import type { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { type DialogTitleProps, Dialog as MuiDialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import Iconify from '../iconify';

const BootstrapDialog = styled(MuiDialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
		padding: theme.spacing(2),
	},
	'& .MuiDialogActions-root': {
		padding: theme.spacing(1),
	},
}));

interface BootstrapDialogTitleProps extends DialogTitleProps {
	onClose?: () => void;
	children?: ReactNode;
}

function BootstrapDialogTitle({ children, onClose, ...other }: BootstrapDialogTitleProps) {
	return (
		<DialogTitle sx={{ m: 0, p: 2 }} {...other}>
			{children}
			{onClose ? (
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<Iconify icon="iconamoon:close-thin" />
				</IconButton>
			) : null}
		</DialogTitle>
	);
}

interface CustomDialogProps {
	open: boolean;
	onClose: () => void;
	title?: string;
	children?: ReactNode;
}

export default function Dialog({ open, onClose, title, children }: CustomDialogProps) {
	return (
		<BootstrapDialog maxWidth="md" onClose={onClose} aria-labelledby="customized-dialog-title" open={open}>
			<BootstrapDialogTitle id="customized-dialog-title" onClose={onClose}>
				{title}
			</BootstrapDialogTitle>
			<DialogContent>{children}</DialogContent>
		</BootstrapDialog>
	);
}
